import { Typography } from '@tempmee/react';
import { BackButton, Box, FloatingContainer, Row, Screen } from '~/commonComponents';
import { ReviewForm } from './components';

export const NPSReview = () => (
  <Screen>
    <FloatingContainer borderRadius={0} paddingBottom={32}>
      <Row
        alignItems="center"
        justifyContent="center"
        marginBottom={32}
        marginTop={44}
        position="relative"
      >
        <Box position="absolute" left={0}>
          <BackButton />
        </Box>
        <Typography as="span" bold size="heading_2">
          GoTu Experience
        </Typography>
      </Row>
      <ReviewForm />
    </FloatingContainer>
  </Screen>
);
